import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchCondutor, type AlteracaoCondutorResponse, type DadosCondutor } from '@services/detran/condutor.service';

export interface AtualizarCondutorInput {
  cpf: string;
  changes: DadosCondutor;
}

export type AtualizarCondutorResult = AlteracaoCondutorResponse;

/**
 * Grava a alteração na base do DETRAN — e para por aí.
 *
 * A secretaria não notifica o Perfil do Cidadão: é o Perfil que consulta as
 * APIs das secretarias via X-Road. O dado novo passa a valer no perfil na
 * próxima coleta do DETRAN, disparada por uma regra de negócio do lado do
 * cidadão (ex.: ele acessar um serviço do DETRAN).
 */
export function useAtualizarCondutor() {
  const queryClient = useQueryClient();

  return useMutation<AtualizarCondutorResult, Error, AtualizarCondutorInput>({
    mutationFn: ({ cpf, changes }) => patchCondutor(cpf, changes),
    onSuccess: (_result, { cpf }) => {
      queryClient.invalidateQueries({ queryKey: ['condutor', cpf] });
    },
  });
}
